import { render, staticRenderFns } from "./DialogTaoThoSuaChua.vue?vue&type=template&id=50ae25ba&scoped=true"
import script from "./DialogTaoThoSuaChua.vue?vue&type=script&lang=js"
export * from "./DialogTaoThoSuaChua.vue?vue&type=script&lang=js"
import style0 from "./DialogTaoThoSuaChua.vue?vue&type=style&index=0&id=50ae25ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50ae25ba",
  null
  
)

export default component.exports